








import { Vue, Component } from 'vue-property-decorator';
import { AuthService } from './services';
import ApiConfig from './services/ApiConfig';
import UniversalLinkRouter from 'src/router/universalLinkRouter';
import { PluginListenerHandle } from '@capacitor/core';
import { App as AppPlugin, AppState} from '@capacitor/app';
import { SplashScreen } from '@capacitor/splash-screen';
import { GlobalEvents } from './constants/GlobalEvents';
import { RouteNames } from './router/routes';
import { RawLocation } from 'vue-router';
import EnvironmentBanner from 'src/components/EnvironmentBanner.vue';


@Component({
  components: { EnvironmentBanner }
})
export default class App extends Vue {
  private readonly authService: AuthService = new AuthService();

  appStateChangeListener: PluginListenerHandle | null = null;
  appUrlOpenListener: PluginListenerHandle | null = null;

  created(): void {
    ApiConfig.AddUnauthorizedHandler(() => {
      this.authService
        .Logout()
        .catch(e => {
          console.error(e);
        })
        .finally(() => {
          if (this.$route.name !== RouteNames.Login && this.$route.name !== RouteNames.SplashScreen) {
            const route: RawLocation = { path: '/login' };

            if (this.$route.fullPath !== '/') {
              route.query = { redirect: this.$route.fullPath };
            }

            void this.$router.push(route);
          }

          if (this.$q.loading.isActive) {
            this.$nextTick(() => {
              this.$q.loading.hide();
            });
          }
        });
    });

    if (this.isNative) {
      void SplashScreen.hide();
      this.setNativeListeners();
    }
  }

  get isNative() {
    return this.$tStore.state.setting.platform != 'web';
  }

  get is_iOS_noToolBar() {
    const noToolBar: Array<string> = [
      RouteNames.Login,
      RouteNames.SplashScreen,
      RouteNames.CompanyToggle,
    ];
    return (
      this.isNative && this.$tStore.state.setting.platform === 'ios' && noToolBar.includes(<string>this.$route.name)
    );
  }

  setNativeListeners() {
    this.appStateChangeListener = AppPlugin.addListener('appStateChange', (state: AppState) => {
      if (state.isActive) {
        this.$root.$emit(GlobalEvents.RefreshData);
      }
    });

    this.appUrlOpenListener = UniversalLinkRouter.AddAppUrlOpenListener(this.$router);
  }

  destroyed() {
    if (this.appStateChangeListener) {
      void this.appStateChangeListener.remove();
    }

    if (this.appUrlOpenListener) {
      void this.appUrlOpenListener.remove();
    }
  }
}
